import { userConstants } from "../constants/login.constants";

function companyOtherDocuments(state = {}, action) {
    switch (action.type) {
        case userConstants.OTHERDOCUMENTS_REQUEST:
            return {
                loading: true,
                ...state,
            };
        case userConstants.OTHERDOCUMENTS_SUCCESS:
            return {
                items: action.companyOtherDocuments
            };
        case userConstants.OTHERDOCUMENTS_FAILURE:
            return {
                error: action.error
            };
        case userConstants.UPLOADOTHERDOCUMENTS_SUCCESS:
            return {
                items: [...state.items, ...action.companyOtherDocuments]
            };
        default:
            return state;
    }
}

export default companyOtherDocuments;